// extracted by mini-css-extract-plugin
export default {"title":"OfferPage_title__sQ+Kh","card":"OfferPage_card__-3ec5","map":"OfferPage_map__5lgFn"};